import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';
import type { SectionColumnType } from '../../../../../models/enum/shared/section-column-type';

@Component({
  selector: 'app-header-column-product-tag-group',
  templateUrl: './header-column-product-tag-group.component.html',
  styleUrl: './header-column-product-tag-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnProductTagGroupComponent extends HeaderColumnComponent {
  @Input() productTagGroupColumnType: SectionColumnType;
}
